// Builds the Vega config for a chart from the CSS custom properties set on
// its wrapper (see src/galette/components/wip/_chart.scss), so Galette stays the source
// of truth for colours and fonts even though Vega only accepts literals.
// Slots defined in src/galette/components/wip/_chart.scss; missing ones are dropped.
const CATEGORY_COUNT = 22

const read = (styles, name, fallback) => {
  const value = styles.getPropertyValue(name).trim()
  return value || fallback
}

export const readChartTokens = element => {
  const styles = getComputedStyle(element)
  return {
    category: Array.from({ length: CATEGORY_COUNT }, (_, i) => read(styles, `--chart-color-${i}`, '')).filter(Boolean),
    axisColor: read(styles, '--chart-axis-color', '#DDD'),
    gridColor: read(styles, '--chart-grid-color', '#EEE'),
    labelColor: read(styles, '--chart-label-color', '#555'),
    font: read(styles, '--chart-font', 'sans-serif')
  }
}

const TOKEN_PREFIX = 'token:'

// Replaces "token:<name>" colour placeholders (Charts::VegaLite::Spec) in the
// spec's colour scale range with the value of the --chart-<name> custom property.
export const resolveSpecTokens = (spec, element) => {
  const range = spec?.encoding?.color?.scale?.range
  if (!Array.isArray(range)) return spec

  const styles = getComputedStyle(element)
  const resolved = range.map(value =>
    typeof value === 'string' && value.startsWith(TOKEN_PREFIX)
      ? read(styles, `--chart-${value.slice(TOKEN_PREFIX.length)}`, '#999')
      : value
  )
  const scale = { ...spec.encoding.color.scale, range: resolved }
  return { ...spec, encoding: { ...spec.encoding, color: { ...spec.encoding.color, scale } } }
}

export const buildVegaConfig = tokens => ({
  background: 'transparent',
  font: tokens.font,
  range: tokens.category.length ? { category: tokens.category } : undefined,
  // Single-series marks have no colour scale, so they take the first palette colour directly.
  mark: tokens.category.length ? { color: tokens.category[0] } : undefined,
  axis: {
    labelColor: tokens.labelColor,
    titleColor: tokens.labelColor,
    titleFontWeight: 'normal',
    labelFontSize: 12,
    titleFontSize: 12,
    domainColor: tokens.axisColor,
    tickColor: tokens.axisColor,
    gridColor: tokens.gridColor
  },
  legend: {
    labelColor: tokens.labelColor,
    labelFontSize: 12,
    labelLimit: 280,
    symbolSize: 80
  },
  view: { stroke: null },
  bar: { discreteBandSize: { band: 0.8 } },
  point: { size: 40, filled: true }
})
